export function errorCode(reason: unknown) {
  if (!reason || typeof reason !== 'object' || !('code' in reason)) return undefined;
  return typeof reason.code === 'string' ? reason.code : undefined;
}
export function errorDetails(reason: unknown) {
  if (!reason || typeof reason !== 'object' || !('details' in reason)) return undefined;
  return reason.details;
}
